import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
// Import Global Components
import { Button } from 'shared-components';
import { openSafeUrl } from 'shared-components/src/utils/safeUrl';
import Text from '../../../components/Text';
// Import Component Styles
import { VirtualCardSection, ListItem } from '../styles';
// Import Translations
import { recoverEn } from '../../../i18n/recover';

const VirtualCardInfo = ({ registerLink, cardholderFeeDisclosureUrl }) => (
  <VirtualCardSection>
    <div>
      <div>
        <Text
          page="recovered"
          text={recoverEn['recovered-sectionTwo-p1-text']}
          textFor="sectionTwo-p1"
        />
      </div>
      <div>
        <Text
          page="recovered"
          text={recoverEn['recovered-sectionTwo-p2-text']}
          textFor="sectionTwo-p2"
        />
        <ul>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li1-text']}
              textFor="sectionTwo-li1"
            />
          </ListItem>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li2-text']}
              textFor="sectionTwo-li2"
            />
          </ListItem>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li3-text']}
              textFor="sectionTwo-li3"
            />
          </ListItem>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li4-text']}
              textFor="sectionTwo-li4"
            />
          </ListItem>
        </ul>
      </div>
      <div>
        <Text
          page="recovered"
          text={recoverEn['recovered-sectionTwo-p4-text']}
          textFor="sectionTwo-p4"
        />
        <ul>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li5-text']}
              textFor="sectionTwo-li5"
            />
          </ListItem>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li6-text']}
              textFor="sectionTwo-li6"
            />
          </ListItem>
          <ListItem>
            <Text
              page="recovered"
              text={recoverEn['recovered-sectionTwo-li7-text']}
              textFor="sectionTwo-li7"
            />
          </ListItem>
        </ul>
      </div>
    </div>
    {cardholderFeeDisclosureUrl && (
      <div style={{ margin: '16px 0' }}>
        <img
          src={cardholderFeeDisclosureUrl}
          alt="Fee Disclosure"
          width="100%"
        />
      </div>
    )}
    <div>
      <Button
        type="primary"
        variant="text"
        onClick={() => window.print()}
      >
        <FormattedMessage
          id="recovered-print-button"
          description="Button for print"
          defaultMessage={recoverEn['recovered-print-button']}
        />
      </Button>
      <Button
        type="primary"
        size="large"
        onClick={() => openSafeUrl(registerLink)}
      >
        <FormattedMessage
          id="recovered-register-button"
          description="Button for register"
          defaultMessage={recoverEn['recovered-register-button']}
        />
      </Button>
    </div>
  </VirtualCardSection>
);

VirtualCardInfo.propTypes = {
  registerLink: PropTypes.string.isRequired,
  cardholderFeeDisclosureUrl: PropTypes.string.isRequired,
};

export default VirtualCardInfo;
